// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__3kuiy","slider":"styles_slider__38666","checkbox":"styles_checkbox__1fWyX","round":"styles_round__2szja"};